import React from "react";
import { Link } from "react-router-dom";
import { FaUserDoctor } from "react-icons/fa6";
import { FaUser } from "react-icons/fa";
import { HiArrowRight } from "react-icons/hi2";
import FooterInner from "../../base/FooterInner";

const RoleSelection = () => {
    return (
        <div className="min-h-screen flex flex-col justify-between bg-slate-100">
            {/* Hero */}
            <section className="relative overflow-hidden bg-gradient-to-br from-brand-500 via-brand-500 to-blue-800 px-6 pt-10 pb-16 lg:px-20 text-center">
                <div className="absolute -top-24 -right-20 h-72 w-72 rounded-full bg-white/10 blur-2xl" />
                <div className="absolute -bottom-24 -left-16 h-72 w-72 rounded-full bg-brand-300/20 blur-2xl" />
                <img alt="Doctora OPD" src="/assets/images/logo-white.svg" className="relative mx-auto h-10 w-auto animate-fade-up" />
                <p className="relative text-sm max-w-3xl mx-auto mt-3 sm:text-base text-white/85 font-medium animate-fade-up">
                    <p className="text-sm max-w-3xl mx-auto mb-4 sm:text-lg text-gray-700 italic font-semibold opacity-0 animate-fade-in delay-[0ms]">
                        <span className='text-white'>Digital</span> OPD to <span className='text-white'>Connect</span> with <span className='text-red-500'>Doctors</span>, manage schedules, and simplify healthcare.
                    </p>
                </p>
            </section>

            {/* Cards */}
            <div className="grow w-full px-4 -mt-9">
                <div className="mx-auto w-full max-w-md space-y-4">
                    {/* User Login — on top */}
                    <Link to="/public-login" className="block animate-fade-up" style={{ animationDelay: '120ms' }}>
                        <div className="group card-surface p-5 flex items-center gap-4 transition-all duration-300 hover:-translate-y-1 hover:shadow-pop ring-1 ring-transparent hover:ring-emerald-200">
                            <div className="grid place-items-center h-14 w-14 rounded-2xl bg-emerald-100 text-emerald-600 text-2xl group-hover:scale-110 transition-transform">
                                <FaUser />
                            </div>
                            <div className="flex-1">
                                <h3 className="font-display text-lg font-bold text-gray-900">Login as User</h3>
                                <p className="text-sm text-gray-500">Book appointments & explore doctors</p>
                            </div>
                            <HiArrowRight className="text-gray-300 text-xl group-hover:text-emerald-500 group-hover:translate-x-1 transition-all" />
                        </div>
                    </Link>

                    {/* Doctor Login — below */}
                    <Link to="/login" className="block animate-fade-up" style={{ animationDelay: '200ms' }}>
                        <div className="group card-surface p-5 flex items-center gap-4 transition-all duration-300 hover:-translate-y-1 hover:shadow-pop ring-1 ring-transparent hover:ring-brand-200">
                            <div className="grid place-items-center h-14 w-14 rounded-2xl bg-brand-100 text-brand-600 text-2xl group-hover:scale-110 transition-transform">
                                <FaUserDoctor />
                            </div>
                            <div className="flex-1">
                                <h3 className="font-display text-lg font-bold text-gray-900">Login as Doctor</h3>
                                <p className="text-sm text-gray-500">Manage appointments, schedules & patients</p>
                            </div>
                            <HiArrowRight className="text-gray-300 text-xl group-hover:text-brand-500 group-hover:translate-x-1 transition-all" />
                        </div>
                    </Link>
                </div>
            </div>

            <section className="mt-10">
                <FooterInner />
            </section>
        </div>
    );
};

export default RoleSelection;
